<template>
  <router-link
    :to="{ name: 'daytimeAdviceSearchView', params: { id: sheet.id }}"
    class="d-flex xs12 ma-1 card--hover result-sheet"
    style="border-radius: 2px"
  >
    <v-card
      :flat="true"
      ripple
      height="100%"
      width="100%"
    >
      <v-card-text>
        <SheetSummaryRow :sheet="sheet" />
      </v-card-text>
    </v-card>
  </router-link>
</template>

<script>
import { SheetSummaryRow } from "../../../entities/daytime-advice-sheet";

export default {
  name: "DaytimeAdviceSearchResultItem",
  components: {
    SheetSummaryRow
  },
  props: {
    sheet: {
      type: Object,
      required: true,
      validator(value) {
        return value && Object.prototype.hasOwnProperty.call(value, "id");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.result-sheet {
  text-decoration: none;

  .v-card__text {
    font-size: 12px;
  }
}
</style>
